<template>
  <!-- 应收款明细表 -->
  <div class="ti d-flex">
    <div class="d-flex-right">
      <div class="cdj_div">预收款汇总表-统计条件</div>
      <div class="cdj_table">
        <div class="cdj_display">
          <div class="cdj_left">
            <div class="cdj_left_display">
              <div class="cdj_left_display_background">房产</div>
              <div class="cdj_el-input">
                <el-select
                  v-model="data.projecta"
                  multiple
                  collapse-tags
                  filterable
                  style="width: 70%"
                  placeholder="选择房产"
                >
                  <el-option
                    size="mini"
                    v-for="item in projecta"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <span style="cursor: pointer" @click="completeProject"
                  >全选</span
                >
                <span
                  style="margin-left: 3px; cursor: pointer"
                  @click="cancelProject"
                  >取消</span
                >
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">发生日期</div>
              <div class="cdj_el-input el-date-pickers">
                <el-date-picker
                  size="mini"
                  v-model="payStartDate"
                  type="date"
                  placeholder="开始时间"
                ></el-date-picker>
                <span class="cdj_text_data">至</span>
                <el-date-picker
                  size="mini"
                  v-model="payEndDate"
                  type="date"
                  placeholder="结束时间"
                ></el-date-picker>
              </div>
            </div>
          </div>
          <!-- 右 -->
          <div class="cdj_left">
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">收费项目</div>
              <div class="cdj_el-input">
                <el-select
                  v-model="data.chargeitemID"
                  multiple
                  filterable
                  collapse-tags
                  style="width: 70%"
                  placeholder="收费项目"
                >
                  <el-option
                    size="mini"
                    v-for="item in chargeitem"
                    :key="item.id"
                    :label="item.chargeItem_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <span style="cursor: pointer" @click="complete">全选</span>
                <span style="margin-left: 3px; cursor: pointer" @click="cancel"
                  >取消</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 1px; margin-top: 10px">
        <el-button
          size="mini"
          type="success text2"
          style="margin-left: 1px"
          @click="excelPost"
          >导出</el-button
        >
      </div>
    </div>
  </div>
</template>
  
  <script>
import imgurl from "../../../assets/js/imgurl.js";
export default {
  name: "AdvancesCollect",
  data() {
    return {
      selectList: [],
      project_id: "",
      payStartDate: "",
      payEndDate: "",
      chargeitem: [],
      chargePercentage: "",
      chargePercentage1: "",
      buttonSize: "1",
      money: "--",
      loading: false,
      desserts: "",

      total: 0,
      page: 12,
      state: 0,
      data: {
        pid: "",
        house_id: "",
        payStartDate: "",
        payEndDate: "",
        chargeitemID: [],
        projecta: [],
        radio: "1",
      },
      projecta: [],
    };
  },
  //界面没出来前加载
  created() {},
  // 加载数据
  mounted() {
    //加载收费大类（费项）
    this.$myhttp
      .get("admin/common/getChargeitem", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.chargeitem = backdata.data.data;
      });
    this.projects();
  },
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
  //事件
  methods: {
    //名下项目
    projects() {
      this.$myhttp
        .get("admin/common/pindex", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.projecta = backdata.data.data;
        });
    },

    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp
          .get(
            "admin/common/house_text?text=" +
              query +
              "&project_id=" +
              this.project_id,
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.selectList = [];
      }
    },
    //导出
    excelPost() {
      this.dates();
      let _this = this;
      this.data.pid = this.data.projecta;
      if (!this.data.pid) {
        _this.$Message.error("房产不能为空");
        return false;
      }
      if (!this.data.payStartDate && !this.data.payEndDate) {
        _this.$Message.error("请选择任意时间范围");
        return false;
      }
      if (this.data.chargeitemID.length == 0) {
        _this.$Message.error("请选择收费项目");
        return false;
      }
      // this.data.pid = this.data.projecta.map(req=>{return req}).join(",");
      ERP.showLoading();
      this.$myhttp
        .post("admin/AdvanceCollect/excel", this.data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          ERP.hideLoading();
          let url = imgurl + backdata.data.data;
          window.open("/office.html#/office?url=" + url, "_blank");
        })
        .catch(function (error) {
          _this.$Message.error("导出失败");
          ERP.hideLoading();
        });
    },
    //全选
    complete() {
      let data = this.chargeitem;
      let id = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      let idarray = "[" + id + "]";
      this.data.chargeitemID = JSON.parse(idarray);
    },
    //取消
    cancel() {
      this.data.chargeitemID = [];
    },
    completeProject() {
      let data = this.projecta;
      let ids = [];
      data.map((req) => {
        ids.push(req.id);
      });
      this.data.projecta = ids;
    },
    //取消
    cancelProject() {
      this.data.projecta = [];
    },

    //时间转换
    dates() {
      this.data.payStartDate = "";
      this.data.payEndDate = "";
      if (this.payStartDate != null && this.payStartDate != "") {
        let d = this.payStartDate; //开始时间
        let payStartDate = new Date(d).getTime() / 1000;
        payStartDate = Number(payStartDate).toFixed(0);
        this.data.payStartDate = payStartDate;
      }
      if (this.payEndDate != null && this.payEndDate != "") {
        let d = this.payEndDate; //开始时间
        let payEndDate = new Date(d).getTime() / 1000;
        payEndDate = Number(payEndDate).toFixed(0);
        this.data.payEndDate = payEndDate;
      }
    },
  },
  watch: {},
};
</script>
  <style scoped>
@import "../../../assets/css/table.css";
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin {
  margin-left: 1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>
  


// WEBPACK FOOTER //
// src/components/Admin/Forms/advancesCollect.vue